/**
 * ⚠️ CRITICAL CONFIGURATION FILE - DO NOT MODIFY WITHOUT REVIEW
 * 
 * This file contains critical configuration for company data handling.
 * Any changes to this file should be reviewed and tested thoroughly.
 */

// API endpoint configuration
export const COMPANY_DATA_CONFIG = {
  // Primary data source - DO NOT CHANGE
  PRIMARY_DATA_SOURCE: '/api/activities-data?type=companies',
  
  // Fallback data sources (in order of preference)
  FALLBACK_SOURCES: [
    '/api/company-stats',
    '/api/user-access-stats'
  ],
  
  // Field mappings for API responses
  FIELD_MAPPINGS: {
    // User statistics fields (snake_case from API)
    USER_STATS: {
      TOTAL_PACKAGES: 'total_packages',
      VIEWED_PACKAGES: 'viewed_packages',
      DOWNLOADED_PACKAGES: 'downloaded_packages',
      RETURNED_PACKAGES: 'returned_packages',
      COMPANY_ACCESS_CODE: 'company_access_code'
    },
    
    // Company statistics fields
    COMPANY_STATS: {
      TOTAL_PACKAGES: 'totalPackages',
      VIEWED_PACKAGES: 'viewedPackages',
      DOWNLOADED_PACKAGES: 'downloadedPackages',
      RETURNED_PACKAGES: 'returnedPackages',
      AWARDED_PACKAGES: 'awardedPackages'
    }
  },
  
  // Loading state configuration
  LOADING_STATES: {
    PRIMARY: 'isLoadingCompanies',
    USERS: 'isLoadingUsers', 
    USER_STATS: 'isLoadingUserStats',
    COMPANY_STATS: 'isLoadingCompanyStats'
  }
} as const;

// Type definitions for better type safety
export type UserStatsFields = typeof COMPANY_DATA_CONFIG.FIELD_MAPPINGS.USER_STATS;
export type CompanyStatsFields = typeof COMPANY_DATA_CONFIG.FIELD_MAPPINGS.COMPANY_STATS;

// Helper functions for safe field access
export const getUserStatField = (userStat: any, field: keyof UserStatsFields): number => {
  return userStat?.[COMPANY_DATA_CONFIG.FIELD_MAPPINGS.USER_STATS[field]] || 0;
};

export const getCompanyStatField = (companyStat: any, field: keyof CompanyStatsFields): number => {
  return companyStat?.[COMPANY_DATA_CONFIG.FIELD_MAPPINGS.COMPANY_STATS[field]] || 0;
};
